import React, {use, createContext, useState, useEffect} from "react";
import PropTypes from "prop-types";
import SyncRegulationsForGroup from "./gql/SyncRegulationsForGroup.graphql";
import GetOneRegulation from "../regulations/gql/getOneRegulation.graphql";
import UpdateOneRegulationGroup from "./gql/UpdateOneRegulationGroup.graphql";
import {useMutation, useQuery} from "@apollo/client";
import {useParams} from "react-router-dom";
import {ALERT} from "../environment";

const GroupsContext = createContext(null);

const GroupsProvider = ({children}) => {
  const [regulationGroup, setRegulationGroup] = useState();
  const [updateRegulationGroup, updateRegulationGroupMethods] =
    useMutation(UpdateOneRegulationGroup);

  const {id} = useParams();

  const getRegulationQuery = useQuery(GetOneRegulation, {
    variables: {id: parseInt(id, 10)},
    skip: !id,
  });

  useEffect(() => {
    if (getRegulationQuery.data) {
      setRegulationGroup(getRegulationQuery.data.regulation);
    }
  }, [getRegulationQuery.data]);

  const [syncGroupRegulations, syncGroupRegulationsMethod] = useMutation(SyncRegulationsForGroup);

  useEffect(() => {
    if (syncGroupRegulationsMethod.data) {
      ALERT.success("Regulation group updated!");
    }
  }, [syncGroupRegulationsMethod.data]);

  const loading =
    syncGroupRegulations.loading ||
    getRegulationQuery.loading ||
    syncGroupRegulationsMethod.loading ||
    updateRegulationGroup.loading ||
    updateRegulationGroupMethods.loading;

  const update = async (data) => {
    await syncGroupRegulations({
      variables: {
        regulationGroup: {id: regulationGroup.id},
        regulations: data.regulations,
      },
    });

    updateRegulationGroup({
      variables: {
        id: regulationGroup.id,
        groupName: {set: data.name},
      },
    });
  };

  return (
    <GroupsContext
      value={{
        update,
        loading,
        regulationGroup,
      }}
    >
      {children}
    </GroupsContext>
  );
};

GroupsProvider.propTypes = {
  children: PropTypes.any.isRequired,
};

const useGroups = () => {
  return use(GroupsContext);
};

export {useGroups, GroupsProvider};
